import React, {Component} from 'react'

class Accessibility extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
           
        };
    }

    componentDidMount() {
      
}

    

render() {
   
     return (
        <div>
        <div class="page-header">
      <div class="container">
         <div class="row">
            <div class="col-md-8">
               <h1>Accessibility</h1>
            </div>
            <div class="col-md-4">
               <ol class="breadcrumb pull-right">
                  <li><a href="/">Home</a></li>
                  <li class="active">Accessibility</li>
               </ol>
            </div>
         </div>
      </div>
   </div>
   <div class="content content-white">
        <div class="container">
        
        <div class="row">
           <div class="col-md-10">


           <h1>educate.y.org Accessibility Statement</h1>


<br /><br />

Updated: December 2019.

<br /><br />

<h2>General</h2>
educate.y.org strives to ensure that its services are accessible to people with disabilities. educate.y.org has invested a significant amount of resources to help ensure that its website is made easier to use and more accessible for people with disabilities, with the strong belief that every person has the right to live with dignity, equality, comfort and independence.

<h2>Accessibility on educate.y.org</h2>
educate.y.org makes available the <a href="https://UserWay.org" alt="Free Website Accessibility Widget" title="Free Website Accessibility Widget">UserWay Website Accessibility Widget</a> that is powered by a dedicated accessibility server. The software allows educate.y.org to improve its compliance with the Web Content Accessibility Guidelines (WCAG 2.1).

<h2>Enabling the Accessibility Menu</h2>
The educate.y.org accessibility menu can be enabled by clicking the accessibility menu icon that appears on the corner of the page. After triggering the accessibility menu, please wait a moment for the accessibility menu to load in its entirety.

<h2>Disclaimer</h2>
educate.y.org continues its efforts to constantly improve the accessibility of its site and services in the belief that it is our collective moral obligation to allow seamless, accessible and unhindered use also for those of us with disabilities.

<br /><br />

In an ongoing effort to continually improve and remediate accessibility issues, we also regularly scan educate.y.org with UserWay's <a href="https://UserWay.org/scanner" title="Free Website Accessibility Scanner">Accessibility Scanner</a> to identify and fix every possible accessibility barrier on our site. Despite our efforts to make all pages and content on educate.y.org fully accessible, some content may not have yet been fully adapted to the strictest accessibility standards. This may be a result of not having found or identified the most appropriate technological solution.

<h2>Here For You</h2>
If you are experiencing difficulty with any content on educate.y.org or require assistance with any part of our site, please contact us during normal business hours as detailed below and we will be happy to assist.

<h2>Contact Us</h2>
If you wish to report an accessibility issue, have any questions or need assistance, please contact educate.y.org Customer Support as follows:

<br /><br />

Email: <a href="mailto:contact@educately.org">contact@educately.org</a>

           </div>
        </div>

     </div>
     </div>
    </div>
         )
         }
         }

export default Accessibility;